import { APP_CONSTANTS } from 'constants/Constants';

const {
  regExValidators: { URL_VALIDATOR, ZIP_VALIDATOR },
} = APP_CONSTANTS;

interface Dictionary<T> {
  [key: string]: T;
}

const CAREER_RULES: Dictionary<any> = {
  title: {
    required: true,
    minLength: 2,
    maxLength: 100,
  },
  category: {
    required: true,
  },
  isFeatured: {
    required: true,
  },
  isPrivate: {
    required: false,
  },
  location: {
    required: true,
  },
  companyName: {
    required: true,
    minLength: 1,
    maxLength: 20,
  },
  zip: {
    required: true,
    minLength: 5,
    maxLength: 5,
    pattern: ZIP_VALIDATOR,
  },
  state: {
    required: true,
  },
  city: {
    required: true,
    minLength: 1,
    maxLength: 20,
  },
  opportunityDescription: {
    required: true,
    minLength: 1,
  },
  hiringDescription: {
    required: true,
    minLength: 1,
  },
  applyThrough: {
    required: true,
  },
  externalUrl: {
    pattern: URL_VALIDATOR,
  },
  industry: {
    required: (window as any).SITE_SHORT_TITLE === 'CCE',
  },
  deadline: {
    required: true,
  },
  idealApplicant: {
    required: true,
  },
  otherIdealApplicant: {
    required: false,
  },
  experience: {
    required: true,
  },
  speciality: {
    required: false,
  },
  fellowship: {
    required: false,
  },
  fellowshipSub: {
    required: false,
  },
  licensedState: {
    required: false,
  },
  minPay: {
    min: 0,
  },
  maxPay: {
    min: 0,
  },
};

export default CAREER_RULES;
